const { linearScale } = require('styled-system-scale')
const { hexToP3 } = require('@walltowall/hex-to-p3')

const sizes = {
  small: '48rem',
  medium: '60rem',
  large: '80rem',
  xlarge: '90rem',
}
const breakpoints = Object.values(sizes)

// Used for linearScale count
const count = breakpoints.length + 1

const theme = {
  /***
   * Sizes
   */
  breakpoints,
  sizes,

  /***
   * Colors
   */
  colors: {
    gray: {
      20: hexToP3('#323539'),
      60: hexToP3('#999'),
    },
    slate: {
      20: hexToP3('#323539'),
      30: hexToP3('#585b61'),
      50: hexToP3('#80858e'),
      60: hexToP3('#a5a8ac'),
      90: hexToP3('#f4f5f6'),
    },
    blue: {
      50: hexToP3('#427ec6'),
      90: hexToP3('#f5f7fb'),
    },
    yellow: {
      60: hexToP3('#f7c948'),
      90: hexToP3('#fffbea'),
    },
    red: {
      50: hexToP3('#e12d39'),
      70: hexToP3('#e09ea3'),
      90: hexToP3('#fff3f3'),
    },
    purple: {
      50: hexToP3('#863dc2'),
      80: hexToP3('#cfb1e7'),
      90: hexToP3('#eee9ef'),
      100: hexToP3('#f9f7f9'),
    },
    green: {
      40: hexToP3('#3b9173'),
      50: hexToP3('#51b894'),
    },
    black: hexToP3('#000'),
    white: hexToP3('#fff'),
  },

  /***
   * Fonts
   */
  fonts: {
    sans: 'Inter, sans-serif',
    mono: "'IBM Plex Mono', sans-serif",
  },
  fontSizeScales: {
    t: linearScale('9px', '10px', { count }),
    s: linearScale('11px', '12px', { count }),
    b: linearScale('13px', '14px', { count }),
    m: linearScale('14px', '16px', { count }),
    l: linearScale('16px', '18px', { count }),
    xl: linearScale('22px', '24px', { count }),
    xxl: linearScale('30px', '42px', { count }),
  },
  fontWeights: {
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    heavy: 800,
  },
  lineHeights: {
    solid: 1,
    title: 1.2,
    ui: 1.4,
    copyTight: 1.6,
    copy: 1.7,
  },
  // TODO: Remove legacy theme values
  fontSizes: {
    micro: '0.625rem',
    tiny: '0.75rem',
    small: '0.875rem',
    normal: '1rem',
    midMedium: '1.1rem',
    medium: '1.5rem',
    large: '2rem',
  },

  /***
   * Spacing
   */
  spaceScales: {
    0: linearScale(0, 0, { count }),
    't-': linearScale('2px', '4px', { count }),
    t: linearScale('4px', '8px', { count }),
    't+': linearScale('6px', '10px', { count }),
    's-': linearScale('10px', '13px', { count }),
    s: linearScale('12px', '18px', { count }),
    m: linearScale('16px', '24px', { count }),
    'm+': linearScale('20px', '30px', { count }),
    l: linearScale('30px', '42px', { count }),
    xl: linearScale('40px', '80px', { count }),
  },
  // TODO: Remove legacy theme values
  space: linearScale('0rem', '30rem', { ratio: 0.5 }),

  /***
   * Transitions
   */
  transitionDurations: {
    slow: '300ms',
    normal: '200ms',
    fast: '100ms',
  },

  /***
   * Variants
   */
  textStyles: {
    caps: {
      textTransform: 'uppercase',
    },
    trackedCaps: {
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    lowercase: {
      textTransform: 'lowercase',
    },
  },
  boxStyles: {
    lastNoMargin: {
      '&:last-child': {
        marginBottom: 0,
        marginRight: 0,
      },
    },
    firstLastNoMargin: {
      '&:first-child': {
        marginTop: 0,
        marginLeft: 0,
      },
      '&:last-child': {
        marginBottom: 0,
        marginRight: 0,
      },
    },
  },

  /***
   * Media queries
   */
  mediaQueries: Object.keys(sizes).reduce((acc, key) => {
    acc[key] = `@media screen and (min-width: ${sizes[key]})`

    return acc
  }, {}),
}

exports.theme = theme
